import React from "react";
import { t } from "ttag";

import { IReviewQueryFacets } from "../../../models/reviews.interfaces";
import { useDispatchers } from "../../reducers";
import { Dispatchers } from "../dispatchers";
import { TextFilterDisplay } from "./TextFilterDisplay";

import styles from "./TextFilter.module.scss";

const FACET_TYPE: IReviewQueryFacets = "text";

interface IProps {
    placeholder?: string;
    maxKeywordsNumber?: number;
}

export const TextFilter = (props: IProps): React.ReactNode => {
    const [currentText, setCurrentText] = React.useState("");
    const { updateFilterOptionValue } = useDispatchers(Dispatchers);

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        setCurrentText(e.currentTarget.value);
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const query = currentText.trim();
        if (!query) {
            return;
        }
        updateFilterOptionValue(FACET_TYPE, query, true);
        setCurrentText("");
    };

    return (
        <>
            <div
                key="text"
                className={`${styles.search} customer-review__side-filters__search`}
            >
                <div
                    className={`${styles.searchBar} customer-review__side-filters__search-bar`}
                >
                    <form
                        action=""
                        className={`${styles.searchForm} customer-review__side-filters__search-form`}
                        onSubmit={onSubmit}
                    >
                        <div className="floating-label using-placeholder-shown">
                            <span className="ada-screenreader-only">
                                {t`Activating this element will cause content on the page to be updated`}
                            </span>
                            <input
                                className={`${styles.searchText} customer-review__side-filters__search-text`}
                                id="text"
                                type="text"
                                name="text"
                                onChange={onChange}
                                value={currentText}
                                placeholder={" "}
                            />
                            <label htmlFor="text">
                                {!props.placeholder
                                    ? t`Search Keywords`
                                    : props.placeholder}
                            </label>
                        </div>
                        <button
                            className={`${styles.searchSubmit} customer-review__side-filters__search-submit`}
                            type="submit"
                            aria-label={t`Search`}
                        >
                            <span
                                aria-hidden="true"
                                className={`${styles.searchIcon} customer-review__side-filters__search-submit__icon`}
                            ></span>
                        </button>
                    </form>
                </div>
            </div>
            <TextFilterDisplay maxKeywordsNumber={props.maxKeywordsNumber} />
        </>
    );
};
